import React from "react";
import { getTransportModeGroupColorHex } from "../../../tools/TransportModeColorsTools";

interface TransportModeBadgeIconProps {
    "mode":              string;
    "iconSrc":           string | undefined;
    "alt":               string;
    "badgeSizePx"?:      number;
    "iconSizePx"?:       number;
    "iconClassName"?:    string;
    "applyWhiteFilter"?: boolean;
}

const TransportModeBadgeIcon: React.FC<TransportModeBadgeIconProps> = ( {
    mode,
    iconSrc,
    alt,
    badgeSizePx = 39,
    iconSizePx = 20,
    iconClassName = "",
    applyWhiteFilter = true,
} ) => {
    if ( iconSrc === undefined ) {
        return null;
    }

    return (
        <span
            className="inline-flex items-center justify-center rounded-full border-[1.5px] border-white shrink-0"
            style={{
                "width":           `${ badgeSizePx }px`,
                "height":          `${ badgeSizePx }px`,
                "backgroundColor": getTransportModeGroupColorHex( mode ),
            }}
        >
            <img
                alt={alt}
                className={iconClassName}
                src={iconSrc}
                style={{
                    "width":  `${ iconSizePx }px`,
                    "height": `${ iconSizePx }px`,
                    ...applyWhiteFilter ? { "filter": "brightness(0) invert(1)" } : {},
                }}
            />
        </span>
    );
};

export default TransportModeBadgeIcon;
